import { supabase } from '../lib/supabase/client';
import { ContactInquiry } from '../types/models';
import { Database } from '../types/database.types';

type ContactRow = Database['public']['Tables']['contact_inquiries']['Row'];
type ContactInsert = Database['public']['Tables']['contact_inquiries']['Insert'];

export const contactService = {
  async getAll(): Promise<ContactInquiry[]> {
    const { data, error } = await supabase
      .from('contact_inquiries')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return (data || []).map((row: ContactRow) => ({
      id: row.id,
      customerName: row.customer_name,
      customerEmail: row.customer_email,
      customerPhone: row.customer_phone,
      subject: row.subject,
      message: row.message,
      inquiryType: row.inquiry_type,
      status: row.status,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
  },

  async create(inquiry: Omit<ContactInquiry, 'id' | 'createdAt' | 'updatedAt' | 'status'>): Promise<ContactInquiry> {
    const insertData: ContactInsert = {
      customer_name: inquiry.customerName,
      customer_email: inquiry.customerEmail,
      customer_phone: inquiry.customerPhone,
      subject: inquiry.subject,
      message: inquiry.message,
      inquiry_type: inquiry.inquiryType,
    };

    const { data, error } = await supabase
      .from('contact_inquiries')
      .insert(insertData)
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      id: data.id,
      customerName: data.customer_name,
      customerEmail: data.customer_email,
      customerPhone: data.customer_phone,
      subject: data.subject,
      message: data.message,
      inquiryType: data.inquiry_type,
      status: data.status,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },
};
function submitContactForm(...args: any[]): any {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: submitContactForm is not implemented yet.', args);
  return null;
}

export { submitContactForm };